import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { getVehicleColours } from '@services/index';
import { VehicleColourOption, VehicleGalleryParams } from 'interface';

export interface VehicleColourOptionsState {
  colourList: VehicleColourOption[];
  error: string | null | boolean;
  loading: boolean;
}

export const initialState: VehicleColourOptionsState = {
  colourList: [],
  error: null,
  loading: false,
};

export const getVehicleColourOptions = createAsyncThunk<
  VehicleColourOption[],
  VehicleGalleryParams
>(
  'vehicleColourOptions/getVehicleColours',
  async (
    vehicleImageGalleryParams: VehicleGalleryParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getVehicleColours(
        vehicleImageGalleryParams.modelCode,
        vehicleImageGalleryParams.doors,
        vehicleImageGalleryParams.trim,
        vehicleImageGalleryParams.train,
        vehicleImageGalleryParams.year
      );

      return response as VehicleColourOption[];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const vehicleColourOptionsSlice = createSlice({
  name: 'vehicleColourOptions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVehicleColourOptions.fulfilled, (state, action) => {
      state.colourList = action.payload;
      state.error =
        (action.payload as VehicleColourOption[]).length == 0 ? true : null;
      state.loading = false;
    });
    builder.addCase(getVehicleColourOptions.rejected, (state, action) => {
      state.colourList = [];
      state.error = action.payload ? (action.payload as string) : true;
      state.loading = false;
    });
    builder.addCase(getVehicleColourOptions.pending, (state) => {
      state.colourList = [];
      state.error = null;
      state.loading = true;
    });
  },
});

export const vehicleColourOptions = (state: RootState) =>
  state.vehicleColourOptions;

export default vehicleColourOptionsSlice.reducer;
